import React from 'react';
import { Box } from '@mui/material';
import { useUserStore } from 'store';

import OnboardingChecklistCard from '../onboarding-checklist/OnboardingChecklistCard';
import { useDashboardActions } from './dashboardActions';
import { can } from '../../utils/access';

/**
 * Onboarding checklist as fixed chrome above the grid, not a widget.
 *
 * The card grows with the step panel the user opens, so a fixed-height grid slot clipped it.
 * It hides itself (per user, backend flag) and disappears for good once every step is done,
 * so it never needed the gallery or a place in the saved layout. `settings.general` is the
 * same key the checklist endpoint checks: without it the request would only 403.
 */
export default function DashboardOnboarding({ dim }) {
  const { currentOrganization } = useUserStore();
  const { open, navigateToMaintenancesWithFilters } = useDashboardActions();
  if (!can(currentOrganization, 'settings.general')) return null;
  return (
    <Box sx={{ opacity: dim ? 0.5 : 1, transition: 'opacity 0.2s ease', pointerEvents: dim ? 'none' : 'auto' }}>
      <OnboardingChecklistCard
        onCreateWorkOrder={() => open('new_wo')}
        onOpenInvoiceables={() => navigateToMaintenancesWithFilters({ states: ['completed'], invoiceStatus: 'no_invoice' })}
      />
    </Box>
  );
}
